import React from 'react';

class TableRow extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <div className={`Table-row ${this.props.className}`}>{this.props.children}</div>;
  }
}

TableRow.propTypes = {
  children: React.PropTypes.node,
  className: React.PropTypes.string
};

TableRow.defaultProps = {
  children: null,
  className: ''
};

export default TableRow;



// WEBPACK FOOTER //
// ./src/js/components/table/Row.js